import { gettext } from '@eventbrite/i18n';

/**  API MESSAGES  **/
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
/* istanbul ignore next */
export const ACCOUNT_STATUS_ERROR_SPEC = {
    default: () => STANDARD_SERVER_ERROR,
};

/**  ACTION MESSAGES  **/
export const NOT_EMAIL_ASSOCIATED_MESSAGE = gettext(
    'There is no account associated with the email.',
);

export const PASSWORD_TOKEN_EXPIRED_MESSAGE = gettext(
    'Your password reset token has expired. Please try again.',
);

export const EMAIL_UNEXISTENT_ERROR_MESSAGE = gettext(
    'We couldn’t find that email address. Please try a different one.',
);

export const SOCIAL_ACCOUNT_ALREADY_LINKED_ERROR_MESSAGE = gettext(
    'Your account is already linked with another account. Please try a different one.',
);

export const ONLY_SOCIAL_LOGIN_ERROR_MESSAGE = gettext(
    'If you’ve logged in through Facebook, you can link your Apple account in account settings',
);
